<div class="mb-2 input-group">
  <input type="text" class="form-control" [(ngModel)]="value" (change)="update()"/>
  <div class="input-group-append">
    <button class="btn btn-outline-danger" (click)="delete()"><i class="bi bi-trash"></i></button>
  </div>
</div>